// extracted by mini-css-extract-plugin
module.exports = {"chomp":"Chomp_chomp__2DhFM","txt_chomp":"Chomp_txt_chomp__10pET"};